/**
 * useCasteListScreen.js
 * ---------------------
 * Hook for Caste Master list screen using shared useMasterList and background JobEngine export.
 */
import { useMasterList } from '../../common/useMasterList';
import * as casteApi from '../api/casteApi';
import { useExportJob } from '../../../../hooks/useExportJob';

export function useCasteListScreen() {
  const master = useMasterList({
    entityName: 'Caste',
    apiClient: casteApi.casteClient,
    fetchList: casteApi.listCastes,
    archiveItem: casteApi.archiveCaste,
    deleteItem: casteApi.deleteCaste,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'caste',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
